<script>
  import { createEventDispatcher } from 'svelte';

  export let presets = [];

  const dispatch = createEventDispatcher();

  function selectPreset(presetKey) {
    dispatch('setPreset', presetKey);
  }
</script>

<div class="pt-7">
  {#each presets as category}
    <div>
      <p class="text-sm font-semibold ml-3">{category.category}</p>
      <div class="flex flex-wrap overflow-x-auto">
        {#each category.items as preset}
          <button 
              class="m-2 p-1 bg-transparent"
              on:click={() => selectPreset(preset.key)}>
            <img 
                class="w-24 h-24 rounded-full border border-gray-300"
                src={preset.img}
            />
          </button>
        {/each}
      </div>
    </div>
  {/each}
</div>
